module.exports = __webpack_public_path__ + "static/media/Depositphotos_4570392_xl-2015.0da40775.png";